import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Flex, Paragraph, Text, Textarea } from '@zillow/constellation';
import { MAX_EMAIL_COUNT, stripNonUnicodeOnInput } from '../DeclineApplicationPage.utils';

const EmailEditor = ({ value, onChange }) => {
  const textareaRef = useRef(null);
  const isEmailError = value.length > MAX_EMAIL_COUNT || value.length === 0;
  const emailFooterTextColor = isEmailError ? 'red600' : 'textMedium';

  useEffect(() => {
    if (textareaRef.current) {
      // dynamically setting `rows={declineReasons.size + X}`is not sufficient since
      // some reasons take up multiple lines, especially when screen size is < desktop
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [textareaRef]);

  return (
    <>
      <Paragraph marginBottom="xs" fontType="bodySmall">
        <strong>Preview and customize your message:</strong>
      </Paragraph>
      <Textarea
        ref={textareaRef}
        value={value}
        error={isEmailError}
        resize="vertical"
        onChange={onChange}
        onInput={stripNonUnicodeOnInput}
        data-test="email-editor__textarea"
      />
      <Flex isError={isEmailError} display="flex" justifyContent="space-between" marginBottom="md">
        <Text fontType="finePrint" fontColor={emailFooterTextColor} data-test="email-editor__char-count-text">
          Character count
        </Text>
        <Text fontType="finePrint" fontColor={emailFooterTextColor} data-test="email-editor__char-count-num">
          {`${value.length}/${MAX_EMAIL_COUNT}`}
        </Text>
      </Flex>
    </>
  );
};

EmailEditor.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default EmailEditor;
